import type { PaginatedMessagingAccount } from '@arhs-fleetback/types/entities/messaging-accounts';

import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/messagingAccounts/actionTypes';
import type { FetchAvailableMessagingAccountsAction, FetchMessagingAccountsSuccessAction } from 'modules/messagingAccounts/types';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';
import type { EntitySlice } from 'utils/ReduxUtils';

const availableAccountAdapter = createEntityAdapter<PaginatedMessagingAccount>({ selectId: ({ id }) => id });

const resetOnFirstPage = (
  state: EntitySlice<PaginatedMessagingAccount>,
  { payload }: FetchAvailableMessagingAccountsAction
) => (payload.request.params.page ? state : availableAccountAdapter.getInitialState());

const addPage = (state: EntitySlice<PaginatedMessagingAccount>, { payload }: FetchMessagingAccountsSuccessAction) =>
  availableAccountAdapter.updateMany(state, payload.content);

const accounts = createReducer(availableAccountAdapter.getInitialState(), {
  [types.FETCH_AVAILABLE_MESSAGING_ACCOUNTS]: resetOnFirstPage,
  [types.FETCH_AVAILABLE_MESSAGING_ACCOUNTS_SUCCESS]: addPage,
});

const known = createReducer(availableAccountAdapter.getInitialState(), {
  [types.FETCH_AVAILABLE_MESSAGING_ACCOUNTS_SUCCESS]: addPage,
});

export default createSearchReducers(types.FETCH_AVAILABLE_MESSAGING_ACCOUNTS, {}, { accounts, known });
